// extracted by mini-css-extract-plugin
export default {"task":"xszgv7af","title":"pncXIM9C","searchWrap":"ZypczwK8","searchInput":"M0jla5HC","farmsWrap":"w3UWLwU1","loading":"TcGdIuiL"};